var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PreventableEvent } from './preventable-event';
/**
 * Arguments for the `legendItemLeave` event.
 */
var LegendItemLeaveEvent = /** @class */ (function (_super) {
    __extends(LegendItemLeaveEvent, _super);
    /**
     * @hidden
     */
    function LegendItemLeaveEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.series = e.series;
        _this.seriesIndex = e.seriesIndex;
        _this.pointIndex = e.pointIndex;
        _this.text = e.text;
        return _this;
    }
    /**
     * @hidden
     */
    LegendItemLeaveEvent.prototype.preventDefault = function () {
        _super.prototype.preventDefault.call(this);
    };
    return LegendItemLeaveEvent;
}(PreventableEvent));
export { LegendItemLeaveEvent };
//# sourceMappingURL=legend-item-leave-event.js.map